import en from "locales/en";
import ru from "locales/ru";
import polyglotI18nProvider from "ra-i18n-polyglot";

const locales: { [key: string]: any } = {
  en,
  ru
}

const getAppliedLocale = () => {
  const locale = navigator.language.substring(0, 2);

  const savedLocale = localStorage.getItem("locale");

  if (savedLocale && Object.keys(locales).includes(savedLocale)) {
    return savedLocale;
  }

  if (Object.keys(locales).includes(locale)) {
    return locale
  }

  return "en"
}

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    localStorage.setItem("locale", locale);
    return locales[locale] ?? en;
  },
  getAppliedLocale()
);
